module.exports = __webpack_public_path__ + "static/img/bg2.678bf24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/UserLogin/bg2.png
// module id = 86Yh
// module chunks = 1